import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import AdminServices from "services/AdminServices";
import {
  Table,
  TableHeader,
  TableCell,
  TableFooter,
  TableContainer,
  Select,
  Input,
  Button,
  Card,
  CardBody,
  Pagination,
} from "@windmill/react-ui";
import { useTranslation } from "react-i18next";
import { FiPlus, FiMail } from "react-icons/fi";
import { can } from "utils/permissions";

import useAsync from "hooks/useAsync";
import useToggleDrawer from "hooks/useToggleDrawer";
import UploadManyTwo from "components/common/UploadManyTwo";
import NotFound from "components/table/NotFound";
// import ProductServices from "services/ProductServices";
import PageTitle from "components/Typography/PageTitle";
import { SidebarContext } from "context/SidebarContext";
import ServiceTable from "components/service/ServiceTable";
import SelectCategory from "components/form/SelectCategory";
import MainDrawer from "components/drawer/MainDrawer";
import ServiceDrawer from "components/drawer/ServiceDrawer";
import CheckBox from "components/form/CheckBox";
import useProductFilter from "hooks/useProductFilter";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import DeleteModal from "components/modal/DeleteModal";
import TableLoading from "components/preloader/TableLoading";
import SettingServices from "services/SettingServices";
import MainModal from "components/modal/MainModal";
import DepartmentServices from "services/DepartementServices";
import DepartmentDrawer from "components/drawer/DepartmentDrawer";
import DepartmentTable from "components/department/DepartmentTable";
import SubscriberDrawer from "components/drawer/SubscriberDrawer";

import Loader from 'components/loader/Loader';
import {

  Badge,

} from "@windmill/react-ui";
import SubscriberServices from "services/SubscriberServices";
import SubscriberTable from "components/subscriber/SubscriberTable";


import * as XLSX from 'xlsx';

import ReactExport from "react-export-excel";
import { jsPDF } from "jspdf";
import 'jspdf-autotable';

const Subscriber = () => {
  const { id, title, subtitle, short_description, description, allId, serviceId, handleDeleteMany, handleUpdateMany } =
    useToggleDrawer();
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchSubscriber, setSearchValue] = useState("");
  const [adminprevilegesList, setAdminprevilegesList] = useState([]);
  const [fullAccess, setFullAccess] = useState(false);
  const [exportData, setExportData] = useState([]);

  const exportToExcel = () => {
    const dataSet = exportData.map(item => ({
      Email: item.email,
     
    }));

    const ws = XLSX.utils.json_to_sheet(dataSet);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "subscribers");
    XLSX.writeFile(wb, "subscribers.xlsx");
  };

  const exportToCSV = () => {
    const csvData = exportData.map(item => [
      item.email,
   
    ]);

    const csvContent = "data:text/csv;charset=utf-8," + csvData.map(e => e.join(",")).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "subscribers.csv");
    document.body.appendChild(link);
    link.click();
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [[t("EmailTbl")]],
      body: exportData.map(item => [
        item.email,
       
      ]),
    });
    doc.save('subscribers.pdf');
  };

  useEffect(() => {
    setExportData(data);
  }, [data]);


  useEffect(() => {
    async function fetchAdminprevileges() {
      try {
        const adminInfoString = Cookies.get("adminInfo");

        if (adminInfoString) {
          const adminInfo = JSON.parse(adminInfoString);

          if (adminInfo && adminInfo.id) {
            const response = await AdminServices.getStaffById(adminInfo.id);

            const adminprevileges = response.data.previleges.map(obj => { return obj.slug });
            setAdminprevilegesList(adminprevileges);
            setFullAccess(!!response.data.full_access);
          } else {
            console.log('ID de l\'admin non trouvé dans les informations');
          }
        } else {
          console.log('Cookie adminInfo non trouvé');
        }
      } catch (error) {
        console.log('Erreur lors de la récupération des privilèges', error);
      }
    }

    fetchAdminprevileges();
  }, []);
  const [status, setStatus] = useState('All');
  const {
    toggleDrawer,
    lang,
    currentPage,
    handleChangePage,
    searchText,
    category,
    setCategory,
    searchRef,
    handleSubmitForAll,
    sortedField,
    setSortedField,
    limitData,
  } = useContext(SidebarContext);

  const fetchSubscribers = async (isLoading, searchSubscriber) => {
    try {
      let response;
      if (searchSubscriber) {
        response = await SubscriberServices.searchSubscriber(searchSubscriber);
      }
      else {
        response = await SubscriberServices.getAllSubscribers();
      }
      // Mettez à jour la variable data avec les données récupérées
      setData(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des Subscribers :", error);
    }
    finally {
      setIsLoading(false); // Mettre à jour l'état pour indiquer que le chargement est terminé
    }
  };

  useEffect(() => {
    fetchSubscribers(isLoading, searchSubscriber); // Appelez la fonction fetchServices pour récupérer les projets au chargement du composant
  }, [isLoading, searchSubscriber]); // Utilisez une dépendance vide pour que cela ne s'exécute qu'une fois au chargement du composant

  const handleSearchInputChange = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue); // Mettez à jour l'état avec la nouvelle valeur de recherche
  };

  // console.log("product page", data);

  // react hooks
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);

  // const handleSelectAll = () => {
  //   setIsCheckAll(!isCheckAll);
  //   setIsCheck(data?.Services.map((li) => li._id));
  //   if (isCheckAll) {
  //     setIsCheck([]);
  //   }
  // };
  const handleSelectAll = () => {
    console.log("isCheck", isCheck);
    setIsCheckAll(!isCheckAll);

    // Check if data and data.Subscriber are defined

    setIsCheck(isCheckAll ? [] : data?.map((subscriber) => subscriber.id));



  };

  // console.log('productss',products)
  const {
    serviceData,
    filename,
    isDisabled,
    handleSelectFile,
    handleUploadMultiple,
    handleRemoveSelectFile,
  } = useProductFilter(data?.Services);

  return (
    <>
      {isLoading ? <Loader /> : null}
      <PageTitle>{t("SubscriberPage")}</PageTitle>

      {/* <BulkActionDrawer ids={allId} data={data} title="Services" /> */}
      <MainDrawer>
        <SubscriberDrawer id={serviceId} setIsCheck={setIsCheck} setIsLoading={setIsLoading} isLoading={isLoading} isCheck={isCheck} />
      </MainDrawer>
      <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
        <CardBody className="">
          <form
            onSubmit={handleSubmitForAll}
            className="py-3 md:pb-0 grid gap-4 lg:gap-6 xl:gap-6  xl:flex"
          >
            <div className="flex justify-start xl:w-1/2  md:w-full">
              {/* <UploadManyTwo
                title="Subscribers"
                filename={filename}
                isDisabled={isDisabled}
                totalDoc={data?.totalDoc}
                handleSelectFile={handleSelectFile}
                handleUploadMultiple={handleUploadMultiple}
                handleRemoveSelectFile={handleRemoveSelectFile}
              /> */}
            </div>
            <div className="lg:flex  md:flex xl:justify-end xl:w-1/2  md:w-full md:justify-start flex-grow-0">
              <div className="w-full md:w-32 lg:w-32 xl:w-32 mr-3 mb-3 lg:mb-0">



                {(can(adminprevilegesList, "send_email_subscribers", fullAccess)) && (

                  <Button
                    disabled={isCheck?.length < 1}
                    onClick={toggleDrawer}
                    className="w-full rounded-md h-12 bg-blue-300 disabled btn-red"
                  >
                    <span className="mr-2">
                      <FiMail />
                    </span>

                    {t("Send email")}
                  </Button>
                )}
              </div>
              <div className="flex-grow-0 md:flex-grow lg:flex-grow xl:flex-grow">

                <Input
                  ref={searchRef}
                  className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                  type="search"
                  name="search"
                  placeholder={t("SearchSubscriber")}
                  onChange={handleSearchInputChange}
                />
                <button
                  type="submit"
                  className="absolute right-0 top-0 mt-5 mr-1"
                ></button>
              </div>
            </div>

          </form>
        </CardBody>
      </Card>

      <p>{isCheckAll}</p>
      {serviceData?.length !== 0 ? (

        <>
          <div className="lg:flex   md:flex s:flex xl:w-1/3 lg:justify-end space-x-1 xl:justify-end ">

            <Button
              onClick={exportToExcel}
              className="flex-1 rounded-md h-5 text-sm"
            >
              {t("Export to Excel")}
            </Button>

            <Button
              onClick={exportToCSV}
              className="flex-1 rounded-md h-5 text-sm"
            >
              {t("Export to CSV")}
            </Button>

            <Button
              onClick={exportToPDF}
              className="flex-1 rounded-md h-5 text-sm"
            >
              {t("Export to PDF")}
            </Button>

          </div>
          <br />
          <TableContainer className="mb-8 rounded-b-lg">

            <Table>
              <TableHeader>
                <tr>
                  <TableCell>
                    {/* <CheckBox
                    type="checkbox"
                    name="selectAll"
                    id="selectAll"
                    isChecked={isCheckAll}
                    handleClick={handleSelectAll}
                  /> */}
                    <CheckBox
                      type="checkbox"
                      name="selectAll"
                      id="selectAll"
                      handleClick={handleSelectAll}
                      isChecked={isCheckAll}
                      setIsCheck={setIsCheck}
                    />

                  </TableCell>
                  <TableCell>{t("ID")}</TableCell>

                  <TableCell>{t("EmailTbl")}</TableCell>
                  <TableCell className="text-right">{t("ActionsTbl")}</TableCell>
                </tr>
              </TableHeader>
              <SubscriberTable
                id={serviceId}
                setIsLoading={setIsLoading}
                isLoading={isLoading}
                lang={lang}
                isCheck={isCheck}
                Subscriber={data?.Subscriber}
                setIsCheck={setIsCheck}
                data={data}
                searchSubscriber={searchSubscriber}
                adminprevilegesList={adminprevilegesList}
                fullAccess={fullAccess}
              />
            </Table>
            {/* <TableFooter>
            <Pagination
              totalResults={data?.totalDoc}
              resultsPerPage={limitData}
              onChange={handleChangePage}
              label="Subscriber Page Navigation"
            />
          </TableFooter> */}
          </TableContainer>
        </>
      ) : (
        <NotFound title="Subscriber" />
      )}
    </>
  );
};

export default Subscriber;
